export const ADD_ONE_PRODUCT = "ADD_ONE_PRODUCT";
export const REMOVE_ONE_PRODUCT = "REMOVE_ONE_PRODUCT";
export const REMOVE_ALL_PRODUCT = "REMOVE_ALL_PRODUCT";
export const INITIALIZE_CART = "INITIALIZE_CART";
export const SET_AMOUNT_PRODUCT = "SET_PRODUCT";
export const ADD_TO_CART = "ADD_TO_CART";

export const add_product_action = (data, customer, unit) => {
  return {
    type: ADD_ONE_PRODUCT,
    payload: data,
    customer: customer,
    unit: unit,
  };
};

export const initialize_cart_action = (data, customer) => {
  return {
    type: INITIALIZE_CART,
    payload: data,
    customer: customer,
  };
};

export const remove_product_action = (data, customer, unit) => {
  return {
    type: REMOVE_ONE_PRODUCT,
    payload: data,
    customer: customer,
    unit: unit,
  };
};

export const set_amount_product_action = (data, customer, amount, unit) => {
  return {
    type: SET_AMOUNT_PRODUCT,
    payload: data,
    customer: customer,
    amount: amount,
    unit: unit,
  };
};

export const remove_all_product_action = (data, customer) => {
  return {
    type: REMOVE_ALL_PRODUCT,
    payload: data,
    customer: customer,
  };
};

export const add_to_cart_action = (data, customer) => {
  return {
    type: ADD_TO_CART,
    payload: data,
    customer: customer,
  };
};
